import { redux } from "./redux";

export { ActivityFeed,  ActivityFeedItem, ActivitySegmentHeader} from "./ActivityFeed";
// export { useRefreshActivityFeed } from "./hooks/useRefreshActivityFeed";

export {
  loadingActivities as refreshActivityFeed,
  waitActivities as waitActivityFeed,
} from "./redux/actions";

export type { Activity } from "./domain/Activity";
export type {
  ActivityFeedItemDefinition,
  BodyProps,
} from "./domain/ActivityFeedItemDefinition";
export const moduleDefinition = {
  module: {
    redux,
  },
};
